import {IFilterFunction} from "angular";
import {OrderLifetime} from "../models/OrderRecord";

export const OrderLifetimeId = "tfOrderLifetime";

export function orderLifetime(): IFilterFunction {
    return (value: OrderLifetime | null) => {
        if (value == null) {
            return null;
        }
        switch (value) {
            case OrderLifetime.DATE:
                return "EXP";
            case OrderLifetime.END_OF_DAY:
                return "EOD";
            case OrderLifetime.FILL_AND_KILL:
                return "FaK";
            case OrderLifetime.FILL_OR_KILL:
                return "FoK";
            case OrderLifetime.GOOD_TILL_CANCEL:
                return "GTC";
            default:
                return value;
        }
    };
}
